var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPreviewshare(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 28,
    height: 28,
    viewBox: "0 0 28 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6
  }, /*#__PURE__*/React.createElement("path", {
    d: "M20.4486 12.2392H16.9206V4.01867C16.9206 2.10055 15.8816 1.71235 14.6143 3.15095L13.7009 4.18993L5.9713 12.9813C4.90948 14.1802 5.35476 15.1621 6.9532 15.1621H10.4812V23.3826C10.4812 25.3007 11.5202 25.6889 12.7875 24.2503L13.7009 23.2113L21.4305 14.4199C22.4923 13.2211 22.047 12.2392 20.4486 12.2392Z",
    fill: "#919191"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPreviewshare);
export default __webpack_public_path__ + "static/media/previewshare.a0aca4aad4777eb77dccf99adbf60533.svg";
export { ForwardRef as ReactComponent };